export default class Newsletter {
  constructor() {
    this.$form = $('form.newsletter-us');
    this.$button = $('.button-newsletter');
  }

  init() {
    this.subscribeNewsletter();
    this.selectPet();
  }

  subscribeNewsletter() {
    this.$form.on('submit', (e) => {
      e.preventDefault();
      const $form = $(e.currentTarget);
      const isWizardForm = $form.attr('id') === 'newsletter-wizard-form';
      const dog = isWizardForm ? 'true' : $form.find('#dog').is(':checked').toString();
      const cat = isWizardForm ? 'true' : $form.find('#cat').is(':checked').toString();
      const aquariology = isWizardForm ? 'true' : $form.find('#aquariology').is(':checked').toString();
      const birds = isWizardForm ? 'true' : $form.find('#birds').is(':checked').toString();
      const rodent = isWizardForm ? 'true' : $form.find('#rodent').is(':checked').toString();
      const privacy = $form.find('#privacy').is(':checked').toString();
      const nameField = $form.find("[name='hpNameSignUp']").val();
      const email = $form.find("[name='hpEmailSignUp']").val();
      const url = $form.attr('action');
      const $container = $form.parents('#newsletter-form');

      const viewData = {
        dog: dog,
        cat: cat,
        aquariology: aquariology,
        birds: birds,
        rodent: rodent,
        privacy: privacy,
        name: nameField,
        email: email,
        token: null
      };

      this.$form.spinner().start();
      $('#newsletter-form').find('.g-recaptcha').addClass('d-block').removeClass('d-none');
      grecaptcha
        .execute($form.find('.g-recaptcha').data('data-sitekey'), {
          action: 'submit'
        })
        .then((token) => {
          const tokenInput = $('#newsletter-token');
          tokenInput.val(token);
          viewData.token = token;

          $.ajax({
            url: url,
            type: 'POST',
            data: jQuery.param(viewData),
            success: (data) => {
              this.$form.spinner().stop();
              $('#newsletter-form').find('.g-recaptcha').addClass('d-none').removeClass('d-block');
              const $title = $container.find('#newsletter-title');
              $title.text(`${data.msg} ${viewData.name}`);

              if (!data.error) {
                $($form).trigger('reset');
              }
            },
            error: () => {
              this.$form.spinner().stop();
              $('#newsletter-form').find('.g-recaptcha').addClass('d-none').removeClass('d-block');
            }
          });
        })
        .catch(() => {
          this.$form.spinner().stop();
          $('#newsletter-form').find('.g-recaptcha').addClass('d-none').removeClass('d-block');
        });
    });
  }

  selectPet() {
    // accessibility for checkbox selection
    $(document).on('keydown', '.pet-item', (e) => {
      if (e.keyCode === 32 || e.code === 'Space' || e.key === ' ' || e.keyCode === 13 || e.code === 'Enter' || e.key === 'Enter') {
        // space
        $(e.currentTarget).trigger('click');
        e.preventDefault();
      }
    });

    $(document).on('click', '.pet-item', (e) => {
      e.preventDefault();
      if ($(e.currentTarget).hasClass('selected')) {
        $(e.currentTarget).removeClass('selected').find('input').prop('checked', false);
      } else {
        $(e.currentTarget).addClass('selected').find('input').prop('checked', true);
      }
    });
  }
}
